module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d65yn"))).then(() => module.bundle.root('6TueN'));